<template>
  <div id="ch_popup_cinema" class="modal-block fade" role="dialog">
    <div class="modal-dialog message-modal" role="document">
      <div class="modal-content" v-if="d_candy">        
          <!--<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>-->
            <div class="modal-content-block">
                <div class="candypop">
                  <div class="candypop-cinema-title">
                      <span>Disponible en:</span>
                  </div>
                  <div class="candypop-cinema-select">
                      <select ref="cines" onchange="ChangeCinemaHomeSelect(this.value)">
                          <option value="0"></option>
                          <template v-for="(cinema,index) in d_candy.Cinemas">
                              <option :value="cinema.CinemaId">{{m_get_cinema_name(cinema.CinemaId)}}</option>
                          </template>
                      </select>
                  </div>
                </div>
            </div>
      </div>
      <div class="modal-content" v-else-if="d_barcode && d_barcode != ''">        
          <!--<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>-->
            <div class="modal-content-block">
                <div class="candypop">
                  <div class="candypop-cinema-title">
                      <span>Disponible en:</span>
                  </div>
                  <div class="candypop-cinema-select">
                      <select ref="cines" onchange="ChangeCinemaHomeSelect(this.value)">
                          <option value="0"></option>
                          <template v-for="(cinema,index) in $root.d_cinemas">
                              <option :value="cinema.CinemaId">{{cinema.strName}}</option>
                          </template>
                      </select>
                  </div>
                </div>
            </div>
      </div>
    </div>	
  </div>
</template>
<script>
import $ from "jquery";

require("./../assets/jquery.bpopup.min.js");

export default {
  name: "popupcinemashome",
  data: function() {
    return {
      d_candy: null,
      d_recogid: null,
      d_recogtypeid: null,
      d_promoid: null,
      d_barcode: null
    };
  },
  computed: {
  },
  updated() {
    $(this.$refs.cines).SumoSelect({nativeOnDevice: [], placeholder: 'Seleccione un Complejo'});
    $(this.$refs.cines).SumoSelect().sumo.reload();
  },
  methods: {
    //Obtengo el nombre del cine
    m_get_cinema_name: function(cinemaId) {
      var cinemaName = "";

      this.$root.d_cinemas.forEach(optionItem => {
        if(optionItem.CinemaId == cinemaId) {
          cinemaName = optionItem.strName;
        }
      });

      return cinemaName;
    },
    //Seteo el object con los atributos a mostrar.
    m_open: function(candy,recogid,recogtypeid,promoid,barcode) {
        this.d_candy = candy;
        this.d_recogid = recogid;
        this.d_recogtypeid = recogtypeid;
        this.d_promoid = promoid;
        this.d_barcode = barcode;
        var bPopup = $(this.$el).bPopup({
            closeClass: "close",
            onClose: function() {
                $(this.$el).remove();
            }
        });
    },
    onChange: function(value){
      if (this.$root.d_App == "True") {
        if(this.d_candy) {
          window.location = this.$root.d_get_url_merch + "nsMerchCandys.aspx?App=1&FeatureId=0&MCode=" + this.d_candy.strMCode + "&RecogId=" + this.d_recogid + "&RecogTypeId=" + this.d_recogtypeid + "&PromoId=" + this.d_promoid + (this.d_candy.strBarcode && this.d_candy.strBarcode != '' ? "&Barcode=" + this.d_candy.strBarcode : "") + "&CinemaId=" + value;
        }
        else {
          window.location = this.$root.d_get_url_merch + "nsMerchCandys.aspx?App=1&FeatureId=0&Barcode=" + this.d_barcode + "&CinemaId=" + value;
        }
      }
      else {
        if(this.d_candy) {
          window.location = this.$root.d_get_url_merch + "nsMerchCandys.aspx?FeatureId=0&MCode=" + this.d_candy.strMCode + "&RecogId=" + this.d_recogid + "&RecogTypeId=" + this.d_recogtypeid + "&PromoId=" + this.d_promoid + (this.d_candy.strBarcode && this.d_candy.strBarcode != '' ? "&Barcode=" + this.d_candy.strBarcode : "") + "&CinemaId=" + value;
        }
        else {
          window.location = this.$root.d_get_url_merch + "nsMerchCandys.aspx?FeatureId=0&Barcode=" + this.d_barcode + "&CinemaId=" + value;
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/PopupCinemasHome.vue